<template>
<nav class="bottom-nav">
    <ul class="gnb-lists">
        <li class="gnb-list" :class="{on : menu.isActive}" v-for="(menu, idx) in menus" :key="idx">
            <a @click="goToLink(menu.path)" style="text-decoration:none;">
                <figure class="gnb-icon">
                    <img :src="menu.isActive ? menu.activeImg : menu.disabledImg" :alt="menu.title">
                </figure>
                <small class="gnb-title">{{menu.title}}</small>
            </a>
        </li>
    </ul>
</nav>
</template>

<script>
export default {
    data() {
        return {
            menus: [{
                    title: "HOME",
                    path: "/home",
                    disabledImg: require("@/assets/image/icon-home.png"),
                    activeImg: require("@/assets/image/icon-home-active.png"),
                    isActive: false,
                },
                {
                    title: "소개",
                    path: "/floor",
                    disabledImg: require("@/assets/image/icon-info.png"),
                    activeImg: require("@/assets/image/icon-info-active.png"),
                    isActive: false
                },
                {
                    title: "서비스",
                    path: "/service",
                    disabledImg: require("@/assets/image/icon-calendar.png"),
                    activeImg: require("@/assets/image/icon-calendar-active.png"),
                    isActive: false
                },
                {
                    title: "포인트",
                    path: "/point",
                    disabledImg: require("@/assets/image/icon-point.png"),
                    activeImg: require("@/assets/image/icon-point-active.png"),
                    isActive: false
                },
                {
                    title: "문의",
                    path: "/inquiry/register",
                    disabledImg: require("@/assets/image/icon-chat.png"),
                    activeImg: require("@/assets/image/icon-chat-active.png"),
                    isActive: false
                },
                {
                    title: "내 정보",
                    path: "/information",
                    disabledImg: require("@/assets/image/icon-user.png"),
                    activeImg: require("@/assets/image/icon-user-active.png"),
                    isActive: false
                }
            ]
        };
    },
    mounted() {
        this.currentPageAcive(this.$route.path);
    },
    methods: {
        currentPageAcive(currentPath) {
            this.menus.forEach(menu => {
                currentPath.includes(menu.path) ? menu.isActive = true : menu.isActive = false;
            });
        },
        goToLink(path) {
            if (path !== this.$route.path) {
                this.$router.push({
                    path: path
                });
            }
        }
    }
};
</script>
